import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Icons from '../../Icons/Icons';
import { LinkContainer } from 'react-router-bootstrap';
import {capitalizeFirstLetter} from '../../../Utils/CommonFunctions';


class ListIcons extends Component {
    state = {
        buttonList:this.props.dropDownList,
        selectedValue:this.props.selectedTypeObj
      }
    defaultOnclickHandler(){
      // alert('sss');
    }
    componentDidUpdate(prevProps){
      if(prevProps.dropDownList !== this.props.dropDownList) {
        this.setState({buttonList:this.props.dropDownList});
      }
      if(prevProps.selectedTypeObj !== this.props.selectedTypeObj) {
        this.setState({selectedValue:this.props.selectedTypeObj});
      }
    }

    render () {
      return (
        <>
          <div className="d-inline-block crmGrids mr-1">
            <a className="btn secondary_bg selected" data-toggle="dropdown">
                {
                  this.state.selectedValue && this.state.selectedValue.svgIcon ?
                    <Icons iconType={this.state.selectedValue.svgIcon} />
                  : null
                }

              <span style={{"color":"#28272d"}}> {capitalizeFirstLetter(this.props.activeView)} View  

                <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 29 29">
                  <path className="arrowDown" fill="none" stroke="#28272d " strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" d="m20.5 11.5-6 6-6-6">
                  </path>
                </svg> 

              </span>               
            </a>
            <ul className="dropdown-menu dropdown-menu-right">
              {this.buttonListHtml(this.state.buttonList,'btn')}
            </ul> 
          </div>
           {/*<a className="btn btn-border border-default dropdown-toggle hidden-caret" data-toggle="dropdown"> <i className="fas fa-caret-down"></i> </a>*/}
          </>
      )
    }

    buttonListHtml = (buttonList,id)=>{
      return buttonList.map((item, i) => {
        const href = (item.href) ? item.href: "#!";
        const eventsHandler = {
          onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
        }
        //{...eventsHandler}
        // console.log('eventsHandler',eventsHandler);
        return(
            <li  className={item.active && item.active === true ? "selected" : ""}>
              <a {...eventsHandler} className="px-2 py-2 dropdown-item" href={href}> 
                  <div className="position-relative">
                      <Icons iconType={item.svgIcon} />
                      <span className="pl-2"> {item.name}</span>
                      {
                        item.active && item.active === true ?
                          <i className="fas fa-check-circle text-success icon-right mt-1"></i>
                        : null
                      }
                  </div>
              </a>                        
            </li>
              
          )
      })
    }

    dropDownButtons = (dropDownItem,i)=>{
      let inlineStyle = (dropDownItem.style)?{...dropDownItem.style}:{};
      let style = {...inlineStyle}
      return(
        <span {...dropDownItem.attributes} style={style}>
            {this.buttonListHtml(dropDownItem.buttonList,i)}
        </span>
      )
    }
    singleButtons = (item,i)=>{
      const buttonIconClass = {
        cancel:"",
        save:"",
        edit:"Edit",
        createNew:"",
        addNew:"AddPlus",
        delete:"Delete",
        email:"EmailSettings"
     }
      const href = (item.href) ? item.href: "#";
          const eventsHandler = {
            onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
          }
          let inlineStyle = (item.style)?{...item.style}:{};
          
          let style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
          style = {...inlineStyle,...style}
          // console.log(buttonIconClass[item.type],item.name);
      return(
        <Wrp key={'wrp'+i}>          
          <LinkContainer key={i} to={href} {...eventsHandler} {...item.attributes} style={style}>
            <a style={style}>
                {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                    <Wrp><i className={item.iconClass}></i>&nbsp;</Wrp>
                :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                  <Icons iconType={item.svgIcon} />
                :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                    <Icons iconType={buttonIconClass[item.type]} />
                :""}
                {item.name}{item.access_mode}
            </a>
          </LinkContainer>
          {(item.children)?
              this.dropDownButtons(item.children,'dropDown'+i)
          :''}          
       </Wrp> 
      )
    }
    
}

ListIcons.defaultProps = {
  iconClass: '',
  svgIcon: ''
}

export default ListIcons;